import axios, {AxiosRequestConfig, AxiosResponse} from 'axios';
import {AppConfig} from '@/app.config';
import {rhizomeDataSource} from "@/modules/Rhizome/datasources/rhizome.datasource";

class Resource {
  getList(keywordId?: number) {
    let options = {};
    if (process.env.VUE_APP_MODE === 'loc' || process.env.VUE_APP_MODE === 'dev') {
      options = { headers: { 'Authorization': AppConfig.authKey ? `Basic ${AppConfig.authKey}` : '' } }
    }
    let url = `${AppConfig.apiUrl}/rhizome`;
    if (keywordId) url += `?keyword=${keywordId}`;

    return (axios.get(url, options) as Promise<AxiosResponse>).then((response: AxiosResponse) => {
      return rhizomeDataSource.convertFilms(response.data);
    });
  }
  
  getKeywords(query) {
    let options = {};
    if (process.env.VUE_APP_MODE === 'loc' || process.env.VUE_APP_MODE === 'dev') {
      options = { headers: { 'Authorization': AppConfig.authKey ? `Basic ${AppConfig.authKey}` : '' } }
    }
    let url = `${AppConfig.apiUrl}/search?key=${query}`;
    return (axios.get(url, options) as Promise<AxiosResponse>).then((response: AxiosResponse) => {
      return rhizomeDataSource.convertKeywords(response.data);
    });
  }
}

export const rhizomeResource = new Resource();
